import React, { FC } from 'react';
import cn from 'classnames';
import styled from 'styled-components';
import { white } from 'crehana-ui/styles/colors';
import IconButton from 'crehana-ui/Buttons/IconButton';
import { IconButtonProps } from 'crehana-ui/Buttons/IconButton/types';

const StyledButton = styled(IconButton)`
  width: 48px !important;
  height: 48px !important;
  & > svg {
    width: 32px !important;
    height: 32px !important;
  }
  @media (min-width: 568px) {
    width: 84px !important;
    height: 84px !important;
    & > svg {
      width: 56px !important;
      height: 56px !important;
    }
  }
`;

const CircularButton: FC<IconButtonProps> = ({ className, ...props }) => (
  <StyledButton
    className={cn('bg-base-main-80 rounded-full', className)}
    customColor={white}
    xs
    {...props}
  />
);

export default CircularButton;
